import { Tag } from "antd";

export const getMineSiteDetailsConfig = (t, data) => [
  {
    label: t('Type of mining operation'),
    render: () => <span>ASM</span>
  },
  {
    label: t('Product(s)'),
    render: () => (
      <div className="products-cont">
        {(data.products || []).map((p) => (
          <Tag key={p.value}>{p.label}</Tag>
        ))}
      </div>
    ),
  },
  {
    label: t('Operator'),
    render: () => <span>{data.operator || '--'}</span>,
  },
  {
    label: t('Equipment / Finance'),
    render: () => <span>{data.finance || '--'}</span>,
  },
  {
    label: t('Legal Form'),
    render: () => <span>{data.legalForm || '--'}</span>,
  },
  {
    label: t('Information Sources'),
    render: () => <span>1</span>,
    // render: () => <span>{data.source || '--'}</span>,
  },
]
